const style = {
  get hover() {
    if (this.touch) {
      return ':active';
    }
    return ':hover';
  },
};

const getCombinedClassNames = (classNames) => (classNames || []).join(' ');

export default style;
export { getCombinedClassNames };
